import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Button,
} from "reactstrap";
import { Clock, MapPin, User, FileText, Camera, X } from "feather-icons-react";
import moment from "moment";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/zoom";
import { formatDate } from "helpers/globalFunction";

const WorkActivitiesDetail = ({ show, onCloseClick, data }: any) => {
  const [showFullNote, setShowFullNote] = useState(false);

  if (!data) return null;

  const images = [
    {
      label: "Area 1",
      url:
        data?.areaOnePicture ||
        "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
    },
    {
      label: "Area 2",
      url:
        data?.areaTwoPicture ||
        "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
    },
    {
      label: "Area 3",
      url:
        data?.areaThreePicture ||
        "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
    },
  ].filter((img) => img.url);

  const truncateText = (text: string, maxLength: number = 150) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const shouldTruncate = data.note && data.note.length > 150;

  return (
    <Modal isOpen={show} toggle={onCloseClick} size="lg" centered scrollable>
      <ModalHeader toggle={onCloseClick} className="border-0 pb-0">
        <div className="d-flex align-items-center">
          <div>
            <h5 className="mb-0">Detail Aktivitas Kerja</h5>
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="p-0">
        <div
          className="bg-gradient p-4"
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          }}
        >
          <Row className="g-3">
            <Col md={6}>
              <Card className="border-0 shadow-sm h-100">
                <CardBody className="p-3">
                  <div className="d-flex align-items-start">
                    <div className="flex-shrink-0">
                      <div className="avatar-md bg-primary bg-opacity-10 rounded-3 d-flex align-items-center justify-content-center">
                        <MapPin size={22} className="text-primary" />
                      </div>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-muted mb-2 small fw-semibold text-uppercase">
                        Lokasi Aktivitas Pekerjaan
                      </p>
                      <h5 className="mb-1">{data.nameCheckPoint}</h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="border-0 shadow-sm h-100">
                <CardBody className="p-3">
                  <div className="d-flex align-items-start">
                    <div className="flex-shrink-0">
                      <div className="avatar-md bg-success bg-opacity-10 rounded-3 d-flex align-items-center justify-content-center">
                        <User size={22} className="text-success" />
                      </div>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-muted mb-2 small fw-semibold text-uppercase">
                        Karyawan
                      </p>
                      <h5 className="mb-2">{data.member?.name}</h5>
                      <div className="d-flex align-items-center gap-2">
                        <Badge color="info" pill className="px-3">
                          {data.member?.noId}
                        </Badge>
                        <Badge color="secondary" pill className="px-3">
                          {data.member?.category}
                        </Badge>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>

        <div className="p-4">
          {images.length > 0 && (
            <Card className="border-0 shadow-sm mb-4">
              <CardBody>
                <div className="d-flex align-items-center mb-3">
                  <div className="avatar-sm bg-info bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3">
                    <Camera size={18} className="text-info" />
                  </div>
                  <div>
                    <h6 className="mb-0">Foto Aktivitas</h6>
                    <small className="text-muted">
                      {images.length} foto dokumentasi
                    </small>
                  </div>
                </div>
                <Swiper
                  modules={[Navigation, Pagination]}
                  spaceBetween={20}
                  slidesPerView={1}
                  navigation
                  pagination={{ clickable: true }}
                  className="mySwiper rounded-3"
                  style={
                    {
                      "--swiper-navigation-color": "#667eea",
                      "--swiper-pagination-color": "#667eea",
                    } as any
                  }
                >
                  {images.map((image, index) => (
                    <SwiperSlide key={index}>
                      <div className="position-relative">
                        <Zoom>
                          <img
                            src={image.url}
                            alt={image.label}
                            className="w-100 rounded-3"
                            style={{
                              cursor: "zoom-in",
                              height: "400px",
                              objectFit: "cover",
                            }}
                          />
                        </Zoom>
                        <div
                          className="position-absolute bottom-0 start-0 end-0 p-3"
                          style={{
                            background:
                              "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                            pointerEvents: "none",
                          }}
                        >
                          <Badge color="light" className="text-dark px-3 py-2">
                            <Camera size={14} className="me-2" />
                            {image.label}
                          </Badge>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <small className="text-muted d-block mt-3 text-center">
                  <em>
                    Klik pada gambar untuk zoom, gunakan navigasi untuk
                    berpindah foto
                  </em>
                </small>
              </CardBody>
            </Card>
          )}

          <Card
            className="border-0 shadow-sm mb-4"
            style={{
              borderLeft: "4px solid #667eea",
            }}
          >
            <CardBody className="py-3">
              <div className="d-flex align-items-center">
                <div className="avatar-sm bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3">
                  <Clock size={18} className="text-primary" />
                </div>
                <div className="flex-grow-1">
                  <small className="text-muted d-block mb-1 fw-semibold">
                    WAKTU
                  </small>
                  <h6 className="mb-0">
                    {formatDate(data.createTime, "fullDateTime")}
                  </h6>
                </div>
              </div>
            </CardBody>
          </Card>

          {data.note && (
            <Card
              className="border-0 shadow-sm mb-4"
              style={{
                borderLeft: "4px solid #f59e0b",
              }}
            >
              <CardBody>
                <div className="d-flex align-items-start mb-3">
                  <div className="avatar-sm bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3">
                    <FileText size={18} className="text-warning" />
                  </div>
                  <h6 className="mb-0 mt-1">Catatan</h6>
                </div>
                <div className="ps-5">
                  <p
                    className="text-muted mb-0"
                    style={{
                      whiteSpace: "pre-wrap",
                      lineHeight: "1.8",
                    }}
                  >
                    {showFullNote || !shouldTruncate
                      ? data.note
                      : truncateText(data.note)}
                  </p>
                  {shouldTruncate && (
                    <Button
                      color="link"
                      size="sm"
                      className="p-0 mt-2 text-decoration-none"
                      onClick={() => setShowFullNote(!showFullNote)}
                    >
                      {showFullNote
                        ? "Tampilkan lebih sedikit"
                        : "Selengkapnya..."}
                    </Button>
                  )}
                </div>
              </CardBody>
            </Card>
          )}

          {data.location && (
            <Card
              className="border-0 shadow-sm"
              style={{
                borderLeft: "4px solid #10b981",
              }}
            >
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3">
                    <MapPin size={18} className="text-success" />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-2">Lokasi</h6>
                    <p className="text-muted mb-0">{data.location}</p>
                  </div>
                </div>
              </CardBody>
            </Card>
          )}
        </div>
      </ModalBody>
      <ModalFooter className="border-0 pt-0">
        <button
          type="button"
          className="btn btn-light px-4 btn-sm"
          onClick={onCloseClick}
        >
          Tutup
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default WorkActivitiesDetail;
